import { render, staticRenderFns } from "./Meta.vue?vue&type=template&id=4c0d5a7d&scoped=true&"
import script from "./Meta.vue?vue&type=script&lang=js&"
export * from "./Meta.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-meta.scss?vue&type=style&index=0&id=4c0d5a7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d5a7d",
  null
  
)

export default component.exports